export function formatClientDate(value, locale) {
  if (!value) {
    return "—";
  }
  try {
    return new Date(value).toLocaleDateString(locale || undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  } catch {
    return "—";
  }
}

export function formatClientDateTime(value, locale) {
  if (!value) {
    return "—";
  }
  try {
    return new Date(value).toLocaleString(locale || undefined, {
      dateStyle: "medium",
      timeStyle: "short",
    });
  } catch {
    return "—";
  }
}

export function formatStatusLabel(status) {
  if (!status) {
    return "—";
  }
  return status
    .split("_")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}
